import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon, DollarSignIcon, SparklesIcon } from 'lucide-react';
export function HowToBook() {
  const steps = [{
    icon: <MessageCircleIcon className="w-6 h-6 text-near-black" data-id="element-260" />,
    title: 'Step 1',
    desc: 'DM or call to check availability'
  }, {
    icon: <DollarSignIcon className="w-6 h-6 text-near-black" data-id="element-261" />,
    title: 'Step 2',
    desc: 'Pay $25 non-refundable deposit'
  }, {
    icon: <SparklesIcon className="w-6 h-6 text-near-black" data-id="element-262" />,
    title: 'Step 3',
    desc: 'Show up, relax, leave looking incredible'
  }];
  return <section id="book" className="py-24 md:py-32 bg-ivory" data-id="element-263">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-264">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-265">
          <h2 className="font-display italic text-4xl md:text-5xl lg:text-6xl text-near-black mb-6" data-id="element-266">
            Ready to get braided?
          </h2>
          <div className="w-16 h-px bg-terracotta mx-auto" data-id="element-267"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 relative mb-16" data-id="element-268">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-10 left-[16%] right-[16%] h-px bg-brand-gold/30 border-dashed border-t-2 border-brand-gold/30" data-id="element-269"></div>

          {steps.map((step, index) => <motion.div key={step.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative flex flex-col items-center text-center z-10" data-id="element-270">
              <div className="w-20 h-20 bg-brand-gold rounded-full flex items-center justify-center mb-6 shadow-lg shadow-brand-gold/20" data-id="element-271">
                {step.icon}
              </div>
              <h3 className="font-display text-2xl font-bold text-near-black mb-3" data-id="element-272">
                {step.title}
              </h3>
              <p className="font-body text-near-black/70 max-w-xs" data-id="element-273">
                {step.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="flex flex-col sm:flex-row items-center justify-center gap-6 text-center" data-id="element-274">
          <div className="bg-cream px-8 py-4 rounded-full shadow-sm border border-warm-brown/5" data-id="element-275">
            <span className="text-sm uppercase tracking-widest text-near-black/50 block mb-1" data-id="element-276">
              Call Us
            </span>
            <a href="tel:2409217857" className="font-display text-2xl text-warm-brown hover:text-burnt-sienna transition-colors" data-id="element-277">
              (240) 921-7857
            </a>
          </div>
          <div className="bg-cream px-8 py-4 rounded-full shadow-sm border border-warm-brown/5" data-id="element-278">
            <span className="text-sm uppercase tracking-widest text-near-black/50 block mb-1" data-id="element-279">
              Instagram
            </span>
            <a href="https://www.instagram.com/roziiepse/" target="_blank" rel="noopener noreferrer" className="font-display text-2xl text-warm-brown hover:text-burnt-sienna transition-colors" data-id="element-280">
              @roziiepse
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}